'use strict';

module.exports = Odigeo.Widget.extend({
    modelClass: require('../modules/models/accommodation_filter_by_our_selection'),
    viewClass: require('../modules/views/accommodation_filter_by_our_selection'),

    onAccommodationSelected: function(value) {
        this.model.set('hotelName', value);
        return this.view.onElementClick();
    },

    checkContainsOurSelection: function(containsOurSelection) {
        this.view.checkContainsOurSelection(containsOurSelection);
    },
});
